import { TurretActor } from "./TurretActor";
import * as Anuto from "../../../../engine/src";
import { AudioManager } from "../../../AudioManager";
import { GameVars } from "../../../GameVars";
import { BattleManager } from "../BattleManager";

export class MortarTurretActor extends TurretActor {

    constructor(scene: Phaser.Scene, position: {r: number, c: number}, turret: Anuto.Turret) {

        super(scene, Anuto.GameConstants.TURRET_MORTAR, position, turret, "texture_atlas_2", false);

        this.base.setFrame("torre_2_" + turret.level + "_01");
        this.base.setOrigin(.5, .75);
        this.add(this.base);

        this.base.on("animationcomplete", () => {
            this.base.setFrame("torre_2_" + this.anutoTurret.level + "_01");
        }, this);
    }

    public upgrade(): void {

        super.upgrade();

        this.base.setFrame("torre_2_" + this.anutoTurret.level + "_01");
    }

    public shootMortar(): void {

        if (GameVars.currentMapZone === 0 && !GameVars.gameData.specialAttacks[0]) {
            if (GameVars.currentMapCount === 1) {

                this.scene.time.addEvent({ delay: 1000, callback: () => {
                    BattleManager.showSpecialAttack(0);
                }, callbackScope: this});
            }
        }

        AudioManager.playSound("bombard");
        
        this.base.anims.play("torre_2_" + this.anutoTurret.level);
    }
}
